<template>
    <div class="report-card">
        <q-expansion-item
            class="bg-white overflow-hidden"
            style="border-radius: 25px"
            icon="person"
            :label="`${customer.firstname} ${customer.lastname}`"
            :caption="`${customer.phone_number}, ${customer.email}`"
            header-class="text-primary"
            expand-icon-class="text-primary"
            v-model="isExpand"
        >
            <q-card>
                <q-card-section v-if="!loading">
                    <div style="padding-left: 16px">
                        <div v-if="stat">
                            Total purchase:
                            <span
                                >฿
                                {{
                                    stat.totalSaleVolume | formattedPrice
                                }}</span
                            >
                        </div>
                        <div v-if="stat">
                            Total Order: <span>{{ stat.totalOrder }}</span>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-12 col-sm-6 text-primary">
                            <q-table
                                title="Frequently purchased products"
                                dense
                                une
                                flat
                                :rows="frequentProductList"
                                :columns="fcolumns"
                                :data="frequentProductList"
                                row-key="cprcode"
                            />
                            <!-- <div v-if="stat">Frequently purchased products</div> -->
                            <!-- <div class="list" style="padding-left: 10px">
                                <li
                                    v-for="(
                                        product, index
                                    ) in frequentProductList"
                                    :key="index"
                                    style="color: #404040"
                                >
                                    {{ product.cprcode }}  {{ product.productName }}
                                </li>
                            </div> -->
                        </div>
                        <div class="col-12 col-sm-6 text-primary q-pl-1">
                            <q-table
                                title="Orders"
                                dense
                                une
                                flat
                                :rows="rows"
                                :columns="columns"
                                :data="rows"
                                row-key="orderID"
                            />
                        </div>
                    </div>
                </q-card-section>
            </q-card>
        </q-expansion-item>
    </div>
</template>

<script>
import { QTable } from "quasar";
import dayjs from "dayjs";
import customParseFormat from "dayjs/plugin/customParseFormat";
// let customParseFormat = require('dayjs/plugin/customParseFormat')
dayjs.extend(customParseFormat);
export default {
    name: "ReportCard",
    props: ["customer"],
    components: {
        QTable,
    },
    data() {
        return {
            firstExpanded: false,
            isExpand: false,
            stat: null,
            frequentProductList: [],
            loading: false,
            columns: [
                {
                    name: "orderId",
                    align: "left",
                    label: "OrderID",
                    field: (row) => row.orderID,
                    sortable: true,
                    require: true,
                },
                {
                    name: "amount",
                    align: "right",
                    label: "Amount (฿)",
                    field: "amount",
                    sortable: false,
                },
                {
                    name: "status",
                    align: "center",
                    label: "Status",
                    field: "status",
                    sortable: false,
                },
                {
                    name: "date",
                    align: "left",
                    label: "DATE",
                    field: "date",
                    sortable: false,
                },
            ],
            rows: [],
            fcolumns: [
                {
                    name: "cprcode",
                    align: "left",
                    label: "Cprcode",
                    field: (row) => row.cprcode,
                    sortable: true,
                    require: true,
                },
                {
                    name: "name",
                    align: "right",
                    label: "Name",
                    field: "productName",
                    sortable: false,
                },
                {
                    name: "quantity",
                    align: "center",
                    label: "Quantity",
                    field: "quantity",
                    sortable: false,
                },
            ],
        };
    },
    watch: {
        isExpand(value) {
            if (value == true) {
                // this.firstExpanded = true;
                this.loadData();
            }
        },
        // firstExpanded(value){
        //   if(value){
        //     this.loadData();
        //   }
        // }
    },
    methods: {
        async loadData() {
            console.log("load data", this.customer.saleID);
            const stat = await this.$services.saleCustomerStat.getAllStat(
                this.customer.saleID
            );
            console.log("stat:", stat);
            this.stat = stat;
            this.frequentProductList = this.calculateFrequentProductList(
                stat.productList
            );
            this.loadOrders(stat.orderList);
        },
        calculateFrequentProductList(productList) {
            productList.sort((a, b) => (a.quantity > b.quantity ? -1 : 1));
            return productList.slice(0, 10);
        },
        async loadOrders(orderList) {
            let orderListData = [];
            // load from pos data
            for (let i = 0; i < orderList.length; i++) {
                const orderId = orderList[i];
                console.log("load pos order:", orderId);
                const response = await this.$services.orders.getPOSOrder(
                    orderId
                );

                const orderData = JSON.parse(response.data);

                console.log(response);

                orderListData.push({
                    orderID: orderId,
                    amount: orderData.posAmount,
                    status: "Success",
                    date: dayjs(
                        response.storeDate.toString(),
                        "YYYYMMDD"
                    ).format("YYYY/MM/DD"),
                });
            }

            orderListData.sort((a, b) => (a.date > b.date ? -1 : 1));

            this.rows = orderListData;
        },
    },
};
</script>

<style scoped>

p {
    padding: 0;
    margin: 0;
}
.report-card {
    margin-top: 10px;
}
.content {
    padding: 10px;
    border-radius: 20px;
    background-color: #f2f3f4;
}

</style>
